import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card } from '../../../components/ui/Card';
import { Badge } from '../../../components/ui/Badge';

const TabNavigation = ({ activeTab, onTabChange, tabs }) => {
  return (
    <Card className="border border-slate-200 shadow-sm bg-white overflow-hidden">
      <div className="flex overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-colors whitespace-nowrap relative ${
              activeTab === tab.id
                ? 'border-slate-600 text-slate-900 bg-slate-50' 
                : 'border-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-50'
            }`}
          >
            <Icon name={tab.icon} size={18} />
            <span>{tab.label}</span>
            {tab.badge && (
              <Badge variant="default" className="text-xs">
                {tab.badge}
              </Badge>
            )}
          </button>
        ))}
      </div>
    </Card>
  );
};

export default TabNavigation;